import { memo } from 'react';
import { alpha, Stack, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import { TIncident } from '../../../../../utility/types/dataProvider';
import ExternalLink from '../../../../Link/ExternalLink';

const Incident = ({ incident }: { incident: TIncident }) => {
  return (
    <Stack
      key={incident?.id}
      direction="row"
      sx={{
        justifyContent: 'flex-start',
        mb: 1,
      }}
    >
      {/* Icon */}
      <FiberManualRecordIcon
        fontSize="small"
        sx={(theme) => {
          const isLightTheme = theme.palette.mode === 'light';
          const blue = isLightTheme
            ? alpha(theme.blox.colors.logoblue, 0.35)
            : theme.blox.colors.darkModeBlue;
          const incidentStatus = Number(incident?.status);
          const incidentStatusColor = [500, 600].includes(incidentStatus)
            ? theme.blox.colors.red
            : [300, 400].includes(incidentStatus)
              ? theme.blox.colors.yellow
              : [200].includes(incidentStatus)
                ? blue
                : incidentStatus === 0
                  ? theme.blox.colors.gray
                  : theme.blox.colors.green;

          return {
            fill: incidentStatusColor,
            mr: 1,
          };
        }}
      />

      {/* Text */}
      <Stack
        direction="column"
        className="incident-link"
        sx={{ mt: '2px' }}
      >
        <ExternalLink
          to={incident?.url ?? '#'}
          sx={{ fontWeight: 500, fontSize: 16, flex: 1 }}
        >
          {incident?.name ?? ''}
        </ExternalLink>

        {/* Components. */}
        <Typography
          variant="subtitle1"
          component="span"
          sx={{ mt: 1 }}
        >
          {incident?.components_affected?.split(',')?.join(', ') ?? ''}
        </Typography>

        {/* Render the container names. */}
        <Typography
          variant="subtitle1"
          component="span"
          sx={{ mt: 1, fontSize: 12 }}
        >
          ({incident?.containers_affected?.split(',')?.join(', ') ?? ''})
        </Typography>
      </Stack>
    </Stack>
  );
};

export default memo(Incident);
